const hiringFormOptions = [
    {value: '', text: 'Любая форма найма'},
    {value: 'staff', text: 'Штат'},
    {value: 'gph', text: 'ГПХ'},
    {value: '__none__', text: 'Не указано'}
];

function hiringFormLabel(value) {
    return value === 'staff' ? 'Штат' : value === 'gph' ? 'ГПХ' : 'Не указано';
}

function matchesHiringForm(employee, filter) {
    return !filter || (filter === '__none__' ? !employee.hiring_form : employee.hiring_form === filter);
}

module.exports = {hiringFormOptions, hiringFormLabel, matchesHiringForm};
